module.exports = __webpack_public_path__ + "static/fonts/LPBambus.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/LPBambus.ttf
// module id = zX8v
// module chunks = 3